/* PHN cart helper (17 Sep 2026). Loaded from layout/theme.liquid after theme.js.
   Configurator lines (hidden _phn_chars property) have no quantity stepper in the
   cart, and Impulse hides its own Remove link inside the cart drawer, so those
   lines could not be removed from the drawer. snippets/cart-item.liquid gives
   them a Remove link marked data-phn-remove; this removes the line in place
   through the theme's own cart code and rebuilds the drawer or cart page. If the
   theme's cart object is missing the link falls through to its href.

   9 Oct 2026 (order #9547): the configurator adds the custom colour setup fee and
   the sign contrast plate as lines of their own, tagged with a hidden _For property
   naming the design. Removing the design left them in the cart, so a customer paid
   a $90 Monument fee on a Matt White number. syncAddons() drops a _For line once
   nothing in the cart needs it: a fee line stays while any line's finish carries
   "[$N extra per order]" for its amount, a plate line stays while a sign with a
   contrast plate and the same text is in the cart. It runs after every cart change
   (cart:updated, fired by the theme's stepper and by the Remove link below) and once
   on page load, which also covers the cart page's plain Remove links. Lines without
   _For (fee products added any other way) are never touched. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function rebuild(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-phn-remove]');
    if (!a) return;
    if (!(window.theme && theme.cart && theme.cart.changeItem)) return;
    e.preventDefault();
    if (a.dataset.phnBusy) return;
    a.dataset.phnBusy = '1';
    var key = a.dataset.phnRemove, item = a.closest('.cart__item');
    if (item) item.style.opacity = '.4';
    theme.cart.changeItem(key, 0).then(function (cart) {
      rebuild(typeof cart === 'string' ? JSON.parse(cart) : cart);
    }).catch(function () { window.location.href = a.href; });
  });

  function orphans(cart) {
    var fees = {}, plates = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      var m = String(p['_4. Choose your finish'] || '').match(/\[\$(\d+) extra per order\]/);
      if (m) fees[m[1]] = true;
      if (p['_5. Add a contrast plate (optional)']) plates.push('"' + p['_2. Enter your text'] + '" on a ');
    });
    return cart.items.filter(function (it) {
      var forDesign = it.properties && it.properties._For;
      if (!forDesign) return false;
      var title = String(it.product_title || '');
      var fee = title.match(/setup fee \$(\d+)/i);
      if (fee) return !fees[fee[1]];
      if (/contrast plate/i.test(title)) return !plates.some(function (pre) { return forDesign.indexOf(pre) === 0; });
      return false;
    });
  }

  var syncing = false;
  function syncAddons(cart) {
    if (syncing) return;
    syncing = true;
    var got = (cart && cart.items) ? Promise.resolve(cart)
      : fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    got.then(function (c) {
      var gone = orphans(c);
      if (!gone.length) return null;
      var updates = {};
      gone.forEach(function (it) { updates[it.key] = 0; });
      return fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    }).then(function (updated) {
      syncing = false;
      if (updated && updated.items) rebuild(updated);
    }).catch(function () { syncing = false; });
  }
  document.addEventListener('cart:updated', function (e) { syncAddons(e.detail && e.detail.cart); });

  function onLoad() { if (/(^|;\s*)cart=/.test(document.cookie)) syncAddons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();
})();
